import React, { useState } from "react";
import "./DCLadekarten.css";

/* ── DATA ─────────────────────────────────────────────────────────────
   Cards per station, sorted cheapest first.
   Update prices here — structure stays the same.
────────────────────────────────────────────────────────────────────── */
const DATA = [
  {
    name: "Aral",
    cards: [
      { provider: "Aral Charge",     price: 0.62 }
    ]
  },
  {
    name: "Allego",
    cards: [
      { provider: "Maingau Energie", price: 0.72 },
      { provider: "Vattenfall",      price: 0.75 }
    ]
  },
  {
    name: "Chargepoint",
    cards: [
      { provider: "Polestar Charge", price: 0.62 },
      { provider: "Maingau Energie", price: 0.72 }
    ]
  },
  {
    name: "E.ON Drive",
    cards: [
      { provider: "Polestar Charge", price: 0.75 }
    ]
  },
  {
    name: "ENBW",
    cards: [
      { provider: "Maingau Energie", price: 0.72 }
    ]
  },
  {
    name: "Fastned",
    cards: [
      { provider: "Polestar Charge", price: 0.72 },
      { provider: "Maingau Energie", price: 0.82 }
    ]
  },
  {
    name: "IONITY",
    cards: [
      { provider: "Maingau Energie", price: 0.62 },
      { provider: "Polestar Charge", price: 0.71 }
    ]
  },
  {
    name: "Shell Recharge",
    cards: [
      { provider: "Shell Recharge",  price: 0.65 }
    ]
  },
  {
    name: "Vattenfall",
    cards: [
      { provider: "Vattenfall",      price: 0.44 }
    ]
  },
  {
    name: "Alle anderen",
    cards: [
      { provider: "Maingau Energie", price: 0.82 }
    ]
  }
];

const SORTED_STATIONS = [...DATA].sort((a, b) => a.name.localeCompare(b.name, "de"));

function fmt(n) {
  return n.toFixed(2).replace(".", ",");
}

function DCLadekarten() {
  const [selected, setSelected] = useState("");

  const station = DATA.find(s => s.name === selected) || null;
  const top = station
    ? [...station.cards].sort((a, b) => a.price - b.price).slice(0, 2)
    : [];
  const isTie = top.length === 2 && top[0].price === top[1].price;
  const hasSavings = top.length === 2 && !isTie;

  return (
    <div className="dc-page">
      <div className="dc-wrap">

        <header className="dc-header">
          <p className="dc-eyebrow">DC Schnellladen</p>
          <h1 className="dc-h1">Welche<br />Ladekarte?</h1>
        </header>

        <div className="dc-field">
          <span className="dc-field-label">Ladestation</span>
          <div className="dc-select-wrap">
            <select
              className="dc-select"
              value={selected}
              onChange={e => setSelected(e.target.value)}
              aria-label="Ladestation auswählen"
            >
              <option value="">— Netz auswählen —</option>
              {SORTED_STATIONS.map(s => (
                <option key={s.name} value={s.name}>{s.name}</option>
              ))}
            </select>
            <svg className="dc-arrow" width="16" height="16" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" strokeWidth="2.5"
              strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>
        </div>

        {selected && (
          <div className="dc-results" role="region" aria-live="polite">
            {top.length === 0 && (
              <p className="dc-empty">Keine Karte für dieses Netz hinterlegt.</p>
            )}
            {top.map((card, i) => (
              <div key={card.provider} className={`dc-card${i === 0 ? " dc-card--best" : ""}`}
                style={{ animationDelay: `${i * 90}ms` }}>
                <div className="dc-badge" aria-label={`Platz ${i + 1}`}>{i + 1}</div>
                <div className="dc-card-body">
                  <div className="dc-provider">{card.provider}</div>
                  <div className="dc-price-row">
                    <span className="dc-price">{fmt(card.price)}</span>
                    <span className="dc-price-unit">&thinsp;€/kWh</span>
                  </div>
                  {isTie && <span className="dc-tie-tag">Gleicher Preis</span>}
                </div>
              </div>
            ))}
            {hasSavings && (
              <div className="dc-savings">
                Karte 1 spart <strong>{fmt(top[1].price - top[0].price)}&thinsp;€/kWh</strong>
                {" — "}bei 50&thinsp;kWh Ladung ca.{" "}
                <strong>{fmt((top[1].price - top[0].price) * 50)}&thinsp;€</strong> günstiger
              </div>
            )}
          </div>
        )}

        <footer className="dc-footer">
          Preise in €/kWh · Stand Juli 2026 · Kein Anspruch auf Vollständigkeit
        </footer>

      </div>
    </div>
  );
}

export default DCLadekarten;
